import { render, staticRenderFns } from "./BaseSearchBar.vue?vue&type=template&id=2d3cddc9&scoped=true"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchBar.vue?vue&type=style&index=0&id=2d3cddc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3cddc9",
  null
  
)

export default component.exports